import { useFlags } from 'launchdarkly-react-client-sdk';
import React, { useEffect, useState } from 'react';

import { $navAbTest } from '../../../stores/nav-ab-test';
import { camelCase } from '../../utils/camel-case';
import { Navbar } from '../navbar';

export function NavAbTest({
	controlModule,
	flagKey,
	navAbTestActive,
	navTransparency,
	variantModule,
}) {
	// hooks
	const flags = useFlags();

	// state
	const [abNavLoaded, setAbNavLoaded] = useState(false);

	// get ab test data
	const abTestKey = camelCase(flagKey);
	const abTestValue = flags[abTestKey];

	useEffect(() => {
		$navAbTest.setKey('active', navAbTestActive);
		$navAbTest.setKey('flagName', abTestKey);
		$navAbTest.setKey('flagValue', abTestValue);
	}, [navAbTestActive, abTestKey, abTestValue]);

	useEffect(() => {
		if (abTestKey && abTestValue) {
			setAbNavLoaded(true);
		}
	}, [abTestKey, abTestValue]);

	const moduleAbTestData =
		abTestValue === 'Variant' ? variantModule : controlModule;

	const moduleData = navAbTestActive ? moduleAbTestData : controlModule;

	// Don't render until we have the flag value
	if (navAbTestActive && !abNavLoaded) {
		return null;
	}

	return (
		<Navbar
			navContent={moduleData?.[0]?.navMenu}
			navTransparency={navTransparency}
		/>
	);
}
